const GET_DETAIL_RTW_INVENTORY_BY_ID = 'GET_DETAIL_RTW_INVENTORY_BY_ID'
const GET_DETAIL_RTW_INVENTORY_BY_ID_SUCCESS = 'GET_DETAIL_RTW_INVENTORY_BY_ID_SUCCESS'

const PUT_RTW_INVENTORY = 'PUT_RTW_INVENTORY'
const PUT_RTW_INVENTORY_SUCCESS = 'PUT_RTW_INVENTORY_SUCCESS'

const GET_RTW_INVENTORY_PAGES = 'GET_RTW_INVENTORY_PAGES'
const GET_RTW_INVENTORY_PAGES_SUCCESS = 'GET_RTW_INVENTORY_PAGES_SUCCESS'


const RtwInventoryTypes = {
  GET_DETAIL_RTW_INVENTORY_BY_ID,
  GET_DETAIL_RTW_INVENTORY_BY_ID_SUCCESS,

  PUT_RTW_INVENTORY,
  PUT_RTW_INVENTORY_SUCCESS,

  GET_RTW_INVENTORY_PAGES,
  GET_RTW_INVENTORY_PAGES_SUCCESS,

}

export default RtwInventoryTypes
